import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid2,
  IconButton,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../Utils/MessagePopup";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { fetchAll, FetchDataGet, postItem, updateItem } from "../../../BaseUrl";
import { GETCLIENT } from "../ClientMaster/Mutation";
import { createposition, updateposition,GETCLIENTDROPDOWN } from "../PositionMaster/mutation";

import { UserContext } from "../../../pages/usercontext/usercontext";

const AddPositionMaster = ({
  formClose,
  editeddata,
  editedtrue,
  setEditedtrue,
  view,
}) => {
  const { isuser } = useContext(UserContext);

  const [userdata, setuserdata] = useState({
    clientname: "",
    positionname: "",
    jobdescription: "",
    clientnameStatus: "unchecked",
    positionnameStatus: "unchecked",
    jobdescriptionStatus: "unchecked",
  });

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clientoptions, setclientoptions] = useState([]);
  const [editid, setEditid] = useState(0);

  useEffect(() => {
    getClientData()
  }, [])
  

  useEffect(() => {
    if (editedtrue === true) {
      getdataforEdit();
    }
  }, [editedtrue]);

  const getClientData = async () => {
    try {
      const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      const response = await FetchDataGet(GETCLIENTDROPDOWN,variables);
      if (response?.getAllClients?.success === true) {
        const data = response?.getAllClients?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName,
        }));
        setclientoptions(data);
      } else {
        setclientoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getdataforEdit = async () => {
    if (!editedtrue) return;

    setEditedtrue(false);
    setIsLoading(true);

    const editedItem = editeddata[0];

    setTimeout(() => {
      setuserdata({
        ...userdata,
        clientname: {
          label: editedItem.clientName,
          value: editedItem.clientId,
        },
        positionname: editedItem.positionName,
        clientnameStatus: "success",
        positionnameStatus: "success",
      });
      setEditid(editedItem.id);
      // setIsLoading(false);
    }, 500);
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...userdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "clientname") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "positionname":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setuserdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const hanldeConfirmDialogSubmit = async () => {
    try {
      if (editid == 0) {
        const variables = {
          input: {
            client: userdata.clientname.value,
            positionName: userdata.positionname,
            createdBy: isuser.username,
          },
        };

        const response = await postItem(createposition, variables);

        if (response.createPosition.success == true) {
          setDialogOpen(false);

          setPopup({
            ...popup,
            open: true,
            message: response.createPosition.message,
            severity: "success",
          });

          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.createPosition.message,
            severity: "error",
          });
        }
      } else {
        const variables = {
          input: {
            id: editid,
            client: userdata.clientname.value,
            positionName: userdata.positionname,
          },
        };
        const response = await updateItem(updateposition, variables);
        if (response.updatePosition.success == true) {
          setDialogOpen(false);
          setPopup({
            ...popup,
            open: true,
            message: response.updatePosition.message,
            severity: "success",
          });
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setDialogOpen(false);

          setTimeout(() => {
            setPopup({
              ...popup,
              open: true,
              message: response.updatePosition.message,
              severity: "error",
            });
          }, 1000);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setuserdata({
      ...userdata,
      clientname: "",
      positionname: "",
      clientnameStatus: "success",
      positionnameStatus: "success",
    });
    formClose();
    setEditid(0);
  };

  const isFormValid = () => {
    return (
      userdata.clientnameStatus == "success" &&
      userdata.positionnameStatus == "success" 
    );
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New Position
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Client
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="clientname"
              placeholder={`Select Client`}
              value={userdata.clientname}
              options={clientoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.clientnameStatus === "error" ? true : false}
              success={userdata.clientnameStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Position Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="positionname"
              placeholder="Enter Position Name"
              value={userdata.positionname}
              onChange={handleAddCourseChange}
              error={userdata.positionnameStatus === "error" ? true : false}
              success={userdata.positionnameStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.positionnameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Position Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          {/* <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Job Description
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="jobdescription"
              placeholder="Enter Job Description"
              value={userdata.jobdescription}
              rows={4}
              multiline
              onChange={handleAddCourseChange}
              error={userdata.jobdescriptionStatus === "error" ? true : false}
              success={
                userdata.jobdescriptionStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.jobdescriptionStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Job Description must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2> */}

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {view == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton onClick={reset} variant="outlined" color="error">
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default AddPositionMaster;
